/**
 * Listing filter "created from" date shown as DD/MM/YYYY; stored as YYYY-MM-DD (İstanbul calendar day).
 */

/** Convert YYYY-MM-DD to DD/MM/YYYY for display. */
export function formatListingCreatedAtYmdToDmy(isoDateYmd: string): string {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(isoDateYmd.trim());
  if (!m) return '';
  const [, y, mo, d] = m;
  return `${d}/${mo}/${y}`;
}

/** Parse DD/MM/YYYY to YYYY-MM-DD, or null if empty/invalid. */
export function parseListingCreatedAtDmyToYmd(input: string): string | null {
  const trimmed = input.trim();
  if (!trimmed) return null;
  const m = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/.exec(trimmed);
  if (!m) return null;
  const day = Number(m[1]);
  const month = Number(m[2]);
  const year = Number(m[3]);
  if (month < 1 || month > 12 || day < 1 || day > 31) return null;
  const dt = new Date(year, month - 1, day);
  if (dt.getFullYear() !== year || dt.getMonth() !== month - 1 || dt.getDate() !== day) return null;
  return `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
}
